<template>
  <div class="mobile-common">
    <img src="@/assets/images/mobile-empty.png" class="img" >
    <p>会员管理项目暂未提供移动版本</p>
    <p>请前往电脑</p>
    <a href="/organization/index" class="btn">知道了</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  mounted () {
    // const deviceWidth = document.documentElement.clientWidth || document.body.clientWidth
    // document.querySelector('html').style.fontSize = deviceWidth / 16 + 'px'
  }
}
</script>

<style scoped lang="scss">
.mobile-common {
  padding: 120px 0;
  text-align: center;
  font-size: 16px;
  .img {
    display: block;
    width: 160px;
    height: 160px;
    margin: 0 auto 24px;
  }
  p {
    color: #808080;
    line-height: 24px;
    font-size: 16px;
  }
  .btn {
    display: block;
    margin-top: 15px;
    font-size: 18px;
  }
}
</style>
